import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.545 1.44a1.1 1.1 0 0 0-.872-.44h-2.53a1.09 1.09 0 0 0-.998.739L9.968 17.296a.314.314 0 0 1-.323.204H6.778a2.63 2.63 0 0 0-2.633 2.64v1.571A1.33 1.33 0 0 0 5.465 23h6.286a2.21 2.21 0 0 0 2.114-1.571l5.838-19.023a1.1 1.1 0 0 0-.158-.966m-3.048 1.131h1.516l-.51 1.572H15.93zm-4.149 18.41a.645.645 0 0 1-.613.448H5.717V20.14a1.07 1.07 0 0 1 1.06-1.069h2.868a1.87 1.87 0 0 0 1.776-1.28l4.03-12.077h1.572z"
    }, null, -1)
  ]))]))
}
export default { render: render }